import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_verify_tip",
  "use": "icon-icon_verify_tip-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon_verify_tip\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"M8 14.667A6.667 6.667 0 1 1 8 1.334a6.667 6.667 0 0 1 0 13.333Zm-.667-7.334v4h1.334v-4H7.333Zm0-2.666V6h1.334V4.667H7.333Z\" fill=\"#FF802F\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol